<template>
    <div class="container container-no-padding" id="shipping_information_form">
        <h3 class="title section-title-26 text-c">{{ $helper.trans('Select_your_way_to_send') }}</h3>
        <div class="steps-block">
            <ul class="steps steps-6">
                <li class="success-step">
                    <span class="step-label">{{ $helper.trans('Order_submission') }}</span>
                </li>
                <li :class="{'active-step': $store.state.shippingTabLevel === 1, 'success-step': $store.state.shippingTabLevel > 1}">
                    <span class="step-label">{{ $helper.trans('Shipping_address') }}</span>
                </li>
                <li :class="{'active-step': $store.state.shippingTabLevel === 2, 'success-step': $store.state.shippingTabLevel > 2}">
                    <span class="step-label">{{ $helper.trans('Receiving_address') }}</span>
                </li>
                <li :class="{'active-step': $store.state.shippingTabLevel === 3, 'success-step': $store.state.shippingTabLevel > 3}">
                    <span class="step-label">{{ $helper.trans('Shipment_information') }}</span>
                </li>
                <li :class="{'active-step': $store.state.shippingTabLevel === 4, 'success-step': $store.state.shippingTabLevel > 4}">
                    <span class="step-label">{{ ($store.state.transportationType === 'export') ? $helper.trans('Courier_call') : $helper.trans('Label_presenting') }}</span>
                </li>
                <li>
                    <span class="step-label">{{ $helper.trans('Payment') }}</span>
                </li>
            </ul>
        </div>
        <div class="content-wrap" id="shipping_information_accordions">
            <shipper-address-block></shipper-address-block>

            <delivery-address-block></delivery-address-block>

            <shipping-information-block></shipping-information-block>

            <fourth-step-information-block></fourth-step-information-block>

            <other-payment-options-block v-if="$store.state.$siteSettings.customer_payment_type === 'all'"></other-payment-options-block>

            <div class="send-block button-block">
                <button @click="backStep();" class="btn btn-border radius-4">{{ $helper.trans('Back') }}</button>
                <button @click="createDraftShipment();" :disabled="requestInProgress" class="btn btn-yellow radius-4">
                    <i v-if="requestInProgress" class="fa fa-spinner fa-spin"></i>
                    {{ $helper.trans('Continue') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    data: function(){
        return {
            requestInProgress: false,
        };
    },
    created: function(){
        let vueThis = this;

        vueThis.$nextTick(function(){
            setTimeout(function(){
                vueThis.$helper.toggleAccordion(vueThis.$store.state.currentLevel);
            }, 250);
        });
    },
    methods: {
        backStep: function(){
            this.$store.state.calculatorState = 'senderServiceSelector';
        },
        createDraftShipment: async function(){
            this.requestInProgress = true;
            await this.$helper.validateAllFieldsAndCreateOrder();
            this.requestInProgress = false;
        },
    },
}
</script>
